export default "__VITE_ASSET__C3Szta8o__"